const MenuItem = ({ children, onClick }) => {
    return (
        <button onClick={onClick} className="p-1.5 content-start text-sf hover:bg-sf-light-100 w-full rounded-lg">
            {children}
        </button>
    );
};

export const MenuItemDivider = () => {
    return <div className="w-full h-px bg-gray-200 my-1" />;
};

export default MenuItem;
